import { FETCH_START, FETCH_SUCCESS, FETCH_ERROR, SET_SELECTED_TEMPLATE, FETCH_WAREHOUSES, FETCH_FLOORS, FETCH_MAPPING, FETCH_STACK_LOCATION } from "../types";
import axios from "../../services/Api";
import { showToast } from "../../services/functions";


export const getSelectedTemplate = (payload, cb) =>
{
    return (dispatch) =>
    {
        dispatch({type: FETCH_START});
        axios.post('dynamicForm/getTemplateDetail',payload).then(({data}) => {
            if (data.success) {
                dispatch({ type: FETCH_SUCCESS });
                dispatch({ type: SET_SELECTED_TEMPLATE, payload: data.data})
            } 
            else {
                dispatch({ type: SET_SELECTED_TEMPLATE, payload: {}})
                dispatch({type: FETCH_ERROR, payload: data.message});
            }

            if(cb){
                cb(data?.data || {})
            }
        }).catch(function (error) {
            dispatch({type: FETCH_ERROR, payload: error.message});
            // //("Error****:", error.message);
            if(cb){
                cb()
            }
        });
    }
};


// export const getItemMasterDetailForInward = (payload, cb) =>
// {
//     return (dispatch) =>
//     {
//         dispatch({type: FETCH_START});
//         axios.post('inventory/getItemMaterDetail',payload).then(({data}) => {
//             if (data.success) {
//                 dispatch({ type: FETCH_SUCCESS });
//             } 
//             else {
//                 dispatch({type: FETCH_ERROR, payload: data.message});
//             }

//             if(cb){
//                 cb(data)
//             }
//         }).catch(function (error) {
//             dispatch({type: FETCH_ERROR, payload: error.message});
//             // //("Error****:", error.message);
//             if(cb){
//                 cb()
//             }
//         });
//     }
// };

// New Scanning API
export const getItemMasterDetailForInward = (payload, cb) =>
{
    return (dispatch) =>
    {
        dispatch({type: FETCH_START});
        axios.post('scan/scanEntityMaterData',payload).then(({data}) => {
            if (data.success) {
                dispatch({ type: FETCH_SUCCESS });
            } 
            else {
                dispatch({type: FETCH_ERROR, payload: data.message});
            }

            if(cb){
                cb(data)
            }
        }).catch(function (error) {
            dispatch({type: FETCH_ERROR, payload: error.message});
            // //("Error****:", error.message);
            if(cb){
                cb()
            }
        });
    }
};


export const getAllWarehouses = ({type}, cb) =>
{
    return (dispatch) =>
    {
        dispatch({type: FETCH_START});
        axios.post('/company/getCompany', {
               type: type
        }).then(({data}) => {
            if (data.success) {
                callback();
            } 
            else {
                dispatch({type: FETCH_ERROR, payload: data.message});
            }
            if(cb){
                cb(data);
            }
            function callback() {
                dispatch({ type: FETCH_SUCCESS });
                dispatch({ type: FETCH_WAREHOUSES, payload: data.data})
            }
        }).catch(function (error) {
            dispatch({type: FETCH_ERROR, payload: error.message});
            // //("Error****:", error.message);
            if(cb){
                cb();
            }
        });
    }
};

export const getWarehouseFloors = ({type, warehouseId}, cb) =>
{
    return (dispatch) =>
    {
        dispatch({type: FETCH_START});
        axios.post('/company/getCompany', {
               type: type,
               warehouseId: warehouseId 
        }).then(({data}) => {
            if (data.success) {
                callback();
            } 
            else {
                dispatch({type: FETCH_ERROR, payload: data.message});
            }
            if(cb){
                cb(data);
            }
            function callback() {
                dispatch({ type: FETCH_SUCCESS });
                dispatch({ type: FETCH_FLOORS, payload: data.data})
            }
        }).catch(function (error) {
            dispatch({type: FETCH_ERROR, payload: error.message});
            // //("Error****:", error.message);
            if(cb){
                cb();
            }
        });
    }
};

export const getFloorMapping = ({ floorId, warehouseId },callback)=>{
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        axios.post('/areaMapping/getAreaMapping', {
            "floorId": floorId,
            "warehouseId": warehouseId,
            "allAreaNameOnly": true,
            "status": ["available", "partial"]
        }).then(({ data }) => {
            if (data.success) {
                dispatch({ type: FETCH_SUCCESS });
                dispatch({ type: FETCH_MAPPING, payload: data?.data || [] })
            }
            else {
                dispatch({ type: FETCH_ERROR, payload: data.message });
            }
            if(callback){
                callback(data?.data || [])
            }
        }).catch(function (error) {
            dispatch({ type: FETCH_ERROR, payload: error.message });
            if(callback){
                callback([])
            }
        });
    }
};

// Fetches the drop-allowed block/rack locations for a warehouse+floor once (not per keystroke),
// mirroring getFloorMapping. Only fetches when both ids are known; otherwise just clears the list.
export const getStackLocation = ({ floorId, warehouseId }, callback) => {
    return (dispatch) => {
        if (!warehouseId || !floorId) {
            dispatch({ type: FETCH_STACK_LOCATION, payload: [] })
            if (callback) callback([])
            return;
        }
        dispatch({ type: FETCH_START });
        axios.post('/grid/getGridDetail', {
            warehouseId,
            floorId,
            type: ["block", "rack"],
            status: ["available", "partial"],
            fetch_for: "drop",
            limit: 1000,
            areaNameOnly: true
        }).then(({ data }) => {
            let formattedData=[]
            if (data.success) {
                formattedData = data?.data?.map((item) => {
                    return {
                        ...item,
                        label: item?.name || "",
                        value: item?.cellId || "",
                        mappingArea: item?.type == "rack"
                            ? (item?.productType ? [item?.productType] : [])
                            : item?.subProductType || []
                    }
                })
                dispatch({ type: FETCH_SUCCESS });
                dispatch({ type: FETCH_STACK_LOCATION, payload: formattedData || [] })
            }
            else {
                dispatch({ type: FETCH_ERROR, payload: data.message });
                dispatch({ type: FETCH_STACK_LOCATION, payload: [] })
            }
            if (callback) callback(formattedData || [])
        }).catch(function (error) {
            dispatch({ type: FETCH_ERROR, payload: error.message });
            dispatch({ type: FETCH_STACK_LOCATION, payload: [] })
            if (callback) callback([])
        });
    }
};

export const saveInwardEntry = (payload, callback) =>
{
    return (dispatch) =>
    {
        dispatch({type: FETCH_START});
        axios.post('/inventory/saveInventoryData', payload).then(({data}) => {
            if (data.success) {
                process(data)
            } 
            else {
                // //(data.message);
                dispatch({type: FETCH_ERROR, payload: data.message});
                showToast(data.message, true)
                callback(null);
            }
            function process(data) {
                dispatch({ type: FETCH_SUCCESS });
                callback(data);
            }
        }).catch(function (error) {
            dispatch({type: FETCH_ERROR, payload: error.message});
            // //("Error****:", error.message);
            callback(null)
        });
    }
};

export const saveInwardEntryThroughExcel = (payload, callback) =>{
    return (dispatch) =>
    {
        dispatch({type: FETCH_START});
        axios.post('/inventory/saveInventoryWithExcel', payload).then(({data}) => {
            if (data.success) {
                process(data)
            } 
            else {
                // console.log(data.message);
                dispatch({type: FETCH_ERROR, payload: data.message});
                showToast(data.message, true)
                callback(null);
            }
            function process(data) {
                dispatch({ type: FETCH_SUCCESS });
                callback(data);
            }
        }).catch(function (error) {
            dispatch({type: FETCH_ERROR, payload: error.message});
            // console.log("Error****:", error.message);
            callback(null)
        });
    }
};

export const saveSinglePackageEntry = (payload, callback) =>
    {
        return (dispatch) =>
        {
            dispatch({type: FETCH_START});
            axios.post('/inventory/singlePackageDataEntry ', payload).then(({data}) => {
                if (data.success) {
                    process(data)
                } 
                else {
                    // //(data.message);
                    dispatch({type: FETCH_ERROR, payload: data.message});
                    showToast(data.message, true)
                    callback(null);
                }
                function process(data) {
                    dispatch({ type: FETCH_SUCCESS });
                    callback(data);
                }
            }).catch(function (error) {
                dispatch({type: FETCH_ERROR, payload: error.message});
                // //("Error****:", error.message);
                callback(null)
            });
        }
    };

export const downloadInventoryDataExcel= (payload, callback) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        axios.post('inventory/downloadInventoryDataExcel', payload).then(({ data }) => {
            if (data.success) {
                dispatch({ type: FETCH_SUCCESS });
            }
            else {
                // //(data.message);
                dispatch({ type: FETCH_ERROR, payload: data.message });
            }
            showToast(data.message, !data.success)
            if(callback){
                callback(data)
            }
        }).catch(function (error) {
            dispatch({ type: FETCH_ERROR, payload: error.message });
            // //("Error****:", error.message);
            callback(null)
        });
    }
};